type OrgChartTextStyles = "h1" | "h2" | "default" | "sourceText";

export interface SizesConfig {
  baseScaleModify: number;
  shape: {
    scaleModify: number;
    strokeWidth: {
      default: number;
      start: number;
      step: number;
    };
    fontSize: number;
    defaultRadius: number;
  };
  stickyNote: {
    marginX: number;
    marginY: number;
    height: number;
    fontSize: number;
  };
  text: {
    fontSize: number;
  };
  nounIcon: {
    size: number;
  };
  icon: {
    size: number;
  };
  table: {
    cornerRadius: number;
    cellWidth: number;
    cellHeight: number;
    fontSize: number;
  };
  mindmap: {
    rootSize: {
      width: number;
      height: number;
    };
    nodeSize: {
      width: number;
      height: number;
    };
  };
  orgChart: {
    thumbnailRadius: number;
    thumbnailRingWidth: number;
    thumbnailPlaceHolderSizeModify: number;
    nodeWidth: number;
    lineWidth: number;
    widgetScale: number;
    borderRadius: number;
    fontSize: Record<OrgChartTextStyles, number>;
  };
  connector: {
    strokeWidth: {
      default: number;
      start: number;
      step: number;
    };
  };
}

export const LegacySizes: SizesConfig = {
  baseScaleModify: 1,
  shape: {
    scaleModify: 1,
    strokeWidth: { default: 4, start: 3, step: 2 },
    fontSize: 16,
    defaultRadius: 100,
  },
  stickyNote: {
    marginX: 20,
    marginY: 20,
    height: 200,
    fontSize: 16,
  },
  text: {
    fontSize: 16,
  },
  nounIcon: {
    size: 100,
  },
  icon: {
    size: 150,
  },
  table: {
    cornerRadius: 10,
    cellWidth: 281,
    cellHeight: 181,
    fontSize: 16,
  },
  mindmap: {
    rootSize: { width: 170, height: 65 },
    nodeSize: { width: 80, height: 30 },
  },
  orgChart: {
    thumbnailRadius: 20,
    thumbnailRingWidth: 2,
    thumbnailPlaceHolderSizeModify: 1,
    nodeWidth: 150,
    lineWidth: 1,
    widgetScale: 1,
    borderRadius: 0,
    fontSize: {
      h1: 12,
      h2: 11,
      default: 10,
      sourceText: 14,
    },
  },
  connector: {
    strokeWidth: {
      default: 4,
      start: 3,
      step: 2,
    },
  },
} as const;

export const CimSizes: SizesConfig = {
  baseScaleModify: 0.6,
  shape: {
    scaleModify: 0.6,
    strokeWidth: { default: 2, start: 1, step: 1 },
    fontSize: 12,
    defaultRadius: 62,
  },
  stickyNote: {
    marginX: 12,
    marginY: 12,
    height: 110,
    fontSize: 12,
  },
  text: {
    fontSize: 14,
  },
  nounIcon: {
    size: 80,
  },
  icon: {
    size: 80,
  },
  table: {
    cornerRadius: 15,
    cellWidth: 238,
    cellHeight: 80,
    fontSize: 12,
  },
  mindmap: {
    rootSize: { width: 190, height: 56 },
    nodeSize: { width: 80, height: 30 },
  },
  orgChart: {
    thumbnailRadius: 25,
    thumbnailRingWidth: 4,
    thumbnailPlaceHolderSizeModify: 1.5,
    nodeWidth: 200,
    lineWidth: 2,
    widgetScale: 1.3,
    borderRadius: 14,
    fontSize: {
      h1: 16,
      h2: 14,
      default: 14,
      sourceText: 14,
    },
  },
  connector: {
    strokeWidth: {
      default: 2,
      start: 1,
      step: 1,
    },
  },
} as const;

export class Sizes {
  static impl: SizesConfig = LegacySizes;
  static enableNew(enable: boolean) {
    Sizes.impl = enable ? CimSizes : LegacySizes;
  }
  static get(): SizesConfig {
    return Sizes.impl;
  }
}
